<template>
    <div class="container-fluid">
        <h1 class="text-left">{{$t('menuItemStatistics')}}</h1>
        <br />
        {{$t('statisticsPageText')}}
        <br />
        <br />
        <div class="col-md-6">
            <b-card no-body>
                <b-card-body>
                    <!-- Choose Statistics type -->
                    <div class="form-group">
                        <base-select :name="'slcStatsType'"
                                     :text="$t('labelShowStatistics')"
                                     v-show="userInfo.licenses.has_mobile_license"
                                     :options="getStatisticsTypesOptions"
                                     :value="statistics_type"
                                     @selected="$_statisticsTypeSelected">
                        </base-select>
                        <b-form-input v-show="!userInfo.licenses.has_mobile_license && userInfo.licenses.has_web_license"
                                      :id="'txtStatsType'"
                                      :name="'txtStatsType'"
                                      plaintext
                                      :value="$t('labelWebTheme')">
                        </b-form-input>
                    </div>
                    <!-- Choose Organizations -->
                    <div v-show="(isStatisticsTypeTheme || isStatisticsTypeTime || isStatisticsTypeWebTheme) && userInfo.isSuper && !loadingOrganizations" class="form-group">
                        <base-select :name="'slcOrg'"
                                     :text="$t('labelOrganization')"
                                     required
                                     :options="getOrganizationOptions"
                                     :value="selected_orgid"
                                     @selected="$_organizationSelected">
                        </base-select>
                    </div>
                    <!-- Loading message -->
                    <b-badge variant="primary" v-show="loadingThemes || loadingWebThemes || (loadingUsers && !isStatisticsTypeTime)">{{ $t('loading') }}</b-badge>
                    <!-- Choose Themes -->
                    <div v-show="isStatisticsTypeTheme && !loadingThemes && !loadingUsers" class="form-group">
                        <base-select :name="'slcTheme'"
                                     :text="$t('theme')"
                                     required
                                     :disabled="userInfo.isSuper && !selected_orgid"
                                     :options="getThemeOptions"
                                     :value="selected_themeid"
                                     @selected="$_themeSelected">
                        </base-select>
                    </div>
                    <!-- Loading message for Users -->
                    <b-badge variant="primary" v-show="loadingUsers && isStatisticsTypeTime">{{ $t('loading') }}</b-badge>
                    <!-- Choose Users -->
                    <div v-show="(isStatisticsTypeTheme || isStatisticsTypeTime) && !loadingThemes && !loadingUsers && !loadingOrganizations" class="form-group">
                        <base-select :name="'slcUser'"
                                     :text="$t('labelUser')"
                                     required
                                     :disabled="userInfo.isSuper && ((isStatisticsTypeTime && !selected_orgid) || (isStatisticsTypeTheme && !selected_themeid))"
                                     :options="getUserOptions"
                                     :value="selected_userid"
                                     @selected="$_userSelected">
                        </base-select>
                    </div>
                    <!-- Choose Webthemes -->
                    <div v-show="isStatisticsTypeWebTheme && !loadingWebThemes" class="form-group">
                        <base-select :name="'slcWebTheme'"
                                     :text="$t('labelWebTheme')"
                                     required
                                     :disabled="userInfo.isSuper && !selected_orgid"
                                     :options="getWebThemeOptions"
                                     :value="selected_webthemeid"
                                     @selected="$_webthemeSelected">
                        </base-select>
                    </div>
                </b-card-body>
            </b-card>
            <br />
            <b-card no-body v-show="isStatisticsTypeTheme || isStatisticsTypeWebTheme || isStatisticsTypeTime">
                <b-card-body>
                    <!-- Start directives-->
                    <StatisticsThemeUser v-show="isStatisticsTypeTheme" ref="childThemeUser" />
                    <StatisticsWebTheme v-show="isStatisticsTypeWebTheme" ref="childWebTheme" />
                    <StatisticsUser v-show="isStatisticsTypeTime" ref="childUser" />
                    <!-- End directives-->
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>
<script>
    import { orderBy } from 'lodash';
    import StatisticsThemeUser from './StatisticsThemeUser.vue';
    import StatisticsWebTheme from './StatisticsWebTheme.vue';
    import StatisticsUser from './StatisticsUser.vue';
    import BaseSelect from '../../components/BaseComponents/base-select.vue';

    export default {
        name: 'StatisticsMain',
        components: {
            StatisticsThemeUser,
            StatisticsWebTheme,
            StatisticsUser,
            'base-select': BaseSelect,
        },

        data: function () {
            return {
                userInfo: {},

                loadingThemes: false,
                loadingOrganizations: false,
                loadingWebThemes: false,
                loadingUsers: false,

                statistics_type: '',

                isStatisticsTypeTheme: false,
                isStatisticsTypeTime: false,
                isStatisticsTypeWebTheme: false,

                selected_orgid: '',
                selected_themeid: '',
                selected_userid: '',
                selected_webthemeid: '',

                organizations: null,
                webthemes: null,
                themes: null,
                users: null
            };
        },

        mounted: function () {
            /**
              * Act as if web statistics was selected, if organization only has web license
              */
            this.$nextTick(function () {
                if (!this.userInfo.licenses.has_mobile_license && this.userInfo.licenses.has_web_license) {
                    // Pick Web statistics
                    this.statistics_type = this.statisticsTypes[0];
                    this.$_statisticsTypeSelected('STAT_WEBTHEME');
                }
            });
        },

        created() {
            this.userInfo = this.$store.getters.userInfo;
        },

        computed: {
            getStatisticsTypesOptions() {
                return this.statisticsTypes.map((item) => {
                    return {
                        id: item.id,
                        value: item.value,
                        text: item.name,
                    };
                });
            },

            getUserOptions() {
                return this.orderedUsers.map((item) => {
                    return {
                        id: item.id,
                        value: `${item.id}`,
                        text: item.userName,
                    };
                });
            },

            getOrganizationOptions() {
                return this.$_getOptions(this.orderedOrganizations);
            },

            getThemeOptions() {
                return this.$_getOptions(this.orderedThemes);
            },

            getWebThemeOptions() {
                return this.$_getOptions(this.orderedWebthemes);
            },

            orderedWebthemes() {
                return orderBy(this.webthemes, [wt => wt.name.toLowerCase()]);
            },

            orderedUsers() {
                return orderBy(this.users, [u => u.userName.toLowerCase()]);
            },

            orderedOrganizations() {
                return orderBy(this.organizations, [o => o.name.toLowerCase()]);
            },

            orderedThemes() {
                return orderBy(this.themes, [t => t.name.toLowerCase()]);
            },

            statisticsTypes() {
                const statisticsTypes = [];

                if (this.userInfo.licenses.has_mobile_license) {
                    statisticsTypes.push({ name: this.$t('theme'), value: 'STAT_THEME' });
                    statisticsTypes.push({ name: this.$t('operatingTime'), value: 'STAT_TIME' });
                }

                if (this.userInfo.licenses.has_web_license) {
                    statisticsTypes.push({ name: this.$t('labelWebTheme'), value: 'STAT_WEBTHEME' });
                }

                return statisticsTypes;
            }
        },
        methods: {
            /**
              * Statistiek keuzelijst geselecteerd event handler
              */
            $_statisticsTypeSelected(value) {
                this.statistics_type = value;
                this.isStatisticsTypeTheme = (this.statistics_type === 'STAT_THEME');
                this.isStatisticsTypeTime = (this.statistics_type === 'STAT_TIME');
                this.isStatisticsTypeWebTheme = (this.statistics_type === 'STAT_WEBTHEME');

                this.selected_userid = '';
                this.users = null;

                if (this.userInfo.isSuper) {
                    this.$_loadOrganizations();
                }

                if (this.isStatisticsTypeTheme) {
                    if (this.userInfo.isSuper) {
                        this.$_organizationSelected(this.selected_orgid);
                    } else {
                        this.selected_orgid = this.userInfo.organizationId;
                        this.$_loadThemes();
                        this.$_loadUsers();
                    }
                } else if (this.isStatisticsTypeTime) {
                    if (this.userInfo.isSuper) {
                        this.$_organizationSelected(this.selected_orgid);
                    } else {
                        this.selected_orgid = this.userInfo.organizationId;
                        this.$_loadUsers();
                        this.$_userSelected();
                    }
                } else if (this.isStatisticsTypeWebTheme) {
                    if (this.userInfo.isSuper) {
                        this.$_organizationSelected(this.selected_orgid);
                    } else {
                        this.selected_orgid = this.userInfo.organizationId;
                        this.$_loadWebthemes();
                    }
                }
            },

            /**
              * Thema keuzelijst geselecteerd event handler
              */
            $_themeSelected(value) {
                this.selected_themeid = value;
                this.selected_userid = '';
                this.$_getStatisticsThemeUserByUserId();
            },

            /**
              * Gebruiker keuzelijst geselecteerd event handler
              */
            $_userSelected(value) {
                this.selected_userid = value;
                if (this.isStatisticsTypeTheme) {
                    this.$_getStatisticsThemeUserByUserId();
                }

                if (this.isStatisticsTypeTime) {
                    this.$_getStatisticsUserByOrgId();
                }
            },

            /**
              * WebThemakaart keuzelijst geselecteerd event handler
              */
            $_webthemeSelected(value) {
                this.selected_webthemeid = value;
                this.$_getStatisticsWebThemeByWebThemeId();
            },

            /**
              * Organisatie keuzelijst geselecteerd event handler
              */
            $_organizationSelected(value) {
                this.selected_orgid = value;

                if (this.isStatisticsTypeTheme) {
                    this.$_setThemeUserOrgId(this.selected_orgid);

                    this.selected_themeid = '';
                    this.selected_userid = '';

                    if (this.selected_orgid) {
                        this.$_loadThemesByOrgId(this.selected_orgid);
                        this.$_loadUsersByOrgId(this.selected_orgid);
                    }
                } else if (this.isStatisticsTypeTime) {
                    this.selected_userid = '';

                    if (this.selected_orgid) {
                        this.$_loadUsersByOrgId(this.selected_orgid);
                    }
                    this.$_getStatisticsUserByOrgId();
                } else if (this.isStatisticsTypeWebTheme) {
                    this.$_setWebThemeOrgId(this.selected_orgid);
                    this.selected_webthemeid = '';

                    if (this.selected_orgid) {
                        this.$_loadWebthemesByOrgId(this.selected_orgid);
                    }
                }
            },

            $_getStatisticsThemeUserByUserId() {
                this.$refs.childThemeUser.getStatisticsThemeUserByUserId(this.selected_themeid, this.selected_userid);
            },

            $_getStatisticsUserByOrgId() {
                this.$refs.childUser.getStatisticsUserByUserId(this.selected_orgid, this.selected_userid);
            },

            $_getStatisticsWebThemeByWebThemeId() {
                this.$refs.childWebTheme.getStatisticsWebThemeWebThemeId(this.selected_webthemeid);
            },

            $_setWebThemeOrgId(id) {
                this.$refs.childWebTheme.getStatisticsWebThemeOrgId(id);
            },

            $_setThemeUserOrgId(id) {
                this.$refs.childThemeUser.getStatisticsThemeUserOrgId(id);
            },

            /**
              * Get all themes for current organization, retrieve only once per scope
              */
            async $_loadThemes() {
                if (!this.themes) {
                    this.loadingThemes = true;
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetAllThemes'
                    });
                    this.themes = result?.data;
                    this.loadingThemes = false;
                }
            },

            /**
              * Get all themes for selected organisation
              * @param  {object} id selected organisation
              */
            async $_loadThemesByOrgId(id) {
                this.loadingThemes = true;
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetAllThemesByOrganizationid',
                    parameters: {
                        organizationId: id
                    }
                });
                this.themes = result?.data;
                this.loadingThemes = false;
            },

            /**
              * Get all webthemes for current organization, retrieve only once per scope
              */
            async $_loadWebthemes() {
                if (!this.webthemes) {
                    this.loadingWebThemes = true;
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetWebThemes'
                    });
                    this.webthemes = result?.data;
                    this.loadingWebThemes = false;
                }
            },

            /**
              * Get all webthemes for selected organisation
              * @param  {object} id selected organisation
              */
            async $_loadWebthemesByOrgId(id) {
                this.loadingWebThemes = true;
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetWebThemesByOrganization',
                    parameters: {
                        organizationId: id
                    }
                });
                this.webthemes = result?.data;
                this.loadingWebThemes = false;
            },

            /**
              * Get all users for current organisation, retrieve only once per scope
              */
            async $_loadUsers() {
                if (!this.users) {
                    this.loadingUsers = true;
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetUserOverview'
                    });
                    this.users = result?.data;
                    this.loadingUsers = false;
                }
            },

            /**
              * Get all users for selected organisation
              * @param  {object} id selected organisation
              */
            async $_loadUsersByOrgId(id) {
                this.loadingUsers = true;
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetAllUsersByOrganizationid',
                    parameters: {
                        organizationId: id
                    }
                });
                this.users = result?.data;
                this.loadingUsers = false;
            },

            /**
              * Get all users for current organization, retrieve only once per scope
              */
            async $_loadOrganizations() {
                if (!this.organizations) {
                    this.loadingOrganizations = true;
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetOrganizations'
                    });
                    this.organizations = result?.data;
                    this.loadingOrganizations = false;
                }
            },

            $_getOptions(arr) {
                return arr.map((item) => {
                    return {
                        id: item.id,
                        value: `${item.id}`,
                        text: item.name,
                    };
                });
            }
        }
    };
</script>
